module.exports = __webpack_public_path__ + "abc48f0c9eed278ae5dfc7cbf54f3c6d.png";